export function readBase64(file: File): Promise<ArrayBuffer> {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    // readAsArrayBuffer guarantees an ArrayBuffer result on load
    reader.addEventListener(
      'load',
      () => resolve(reader.result as ArrayBuffer),
      false,
    );
    reader.addEventListener('error', (event) => reject(event), false);

    reader.readAsArrayBuffer(file);
  });
}
